import {createSelector} from '@reduxjs/toolkit'

import {first} from '@shared/helpers/array'

import {APIStatus, PreferredPoint, PreferredPointType} from '@web/core/constants'

import {RootState} from './interfaces'

/** 충전 포인트 Selector */
export const pointPaymentSelector = (state: RootState) => state.pointPayment

export const naverPayPointSelector = createSelector(
    (state: RootState) => state.pointPayment.naverPayPoint,
    ({amount, usePointAll, usingAmount, preferredPoint, status}) => {
        const {sequences, apiStatus} = preferredPoint
        const preferredType: PreferredPointType = first(sequences) ?? PreferredPoint.REWARD_POINT
        return {
            /** 총 보유 포인트 */
            amount,
            /** 포인트 전액 사용 여부 */
            usePointAll,
            /** 사용할 포인트 금액 */
            usingAmount,
            /** 소진 정보 */
            preferredInfo: {
                type: preferredType,
                sequences,
                isSuccess: apiStatus === APIStatus.RESOLVED,
            },
            /** 포인트 사용 가능 상태 */
            status,
        }
    },
)
